<div class="card">
    <div class="p-col-12 p-md-6">
        <div class="card">
            <div class="p-fluid">
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <label for="opt">{{lbl_period}}</label>
                    <div class="p-col-6 p-md-10">
                        <p-dropdown [options]="listPeriods" [(ngModel)]="selectedPeriod" optionLabel="descrip"
                            [showClear]="true" placeholder="{{lbl_select}} {{lbl_period}}"></p-dropdown>
                    </div>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="p-mr-2 p-mb-2">
                        <p-button label="{{lbl_search}}" icon="pi pi-search" (onClick)="search()"
                            loading="loadingSearch"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_guide}}:</span>
                    <span class="p-text-bold">{{guide!=null?guide.name:""}} {{guide!=null?guide.lastName:""}}
                    </span>
                    <span>{{lbl_coordination}}:</span>
                    <span class="p-text-bold">{{store!=null?store.descri:""}}
                    </span>
                    <span>{{lbl_status}}:</span>
                    <span class="p-text-bold">{{guide!=null?guide.status:""}} - {{statusGuide!=null?statusGuide:""}}
                        {{quitDesc!=null?quitDesc:""}}
                    </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_id}}:</span>
                    <span class="p-text-bold">{{guide!=null?guide.guideId:""}}
                    </span>
                    <span>{{lbl_certificate}}:</span>
                    <span class="p-text-bold">{{guide!=null?guide.certif:""}}
                    </span>
                    <span>{{lbl_sent_Date}}:</span>
                    <span class="p-text-bold">{{guide!=null?guide.sentDay:""}} / {{guide!=null?guide.sentMont:""}} /
                        {{guide!=null?guide.sentYear:""}}
                    </span>
                </div>
            </p-panel>
        </div>
        <div class="p-col-12 p-md-6">
            <p-panel>

                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_annual_quote}} {{selectedPeriod?.year}}:</span>
                    <span class="p-text-bold">{{guideAnnualQ!=null?guideAnnualQ.amount:0.00}}</span>
                    <span>Casa Fundacional {{selectedPeriod?.year}}:</span>
                    <span class="p-text-bold">{{guideFunda!=null?guideFunda.amount:0.00}}</span>
                    <span>{{lbl_offering}}:</span>
                    <span class="p-text-bold">{{guideOffer!=null?guideOffer.amount:0.00}}</span>
                    <span>{{lbl_material_balance}}:</span>
                    <span class="p-text-bold">{{pendAmount!=null?pendAmount:""}}</span>
                </div>
            </p-panel>
        </div>


        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <p-table #dt [value]="lstSum" [globalFilterFields]="['itemId','descri']" [rowHover]="true"
                        dataKey="id" styleClass="p-datatable-responsive-demo"
                        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
                        [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <h5 class="p-m-0">{{lbl_item}}</h5>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="{{lbl_search}}"/>
                                </span>
                            </div>

                            <span class="p-input-icon-left">
                                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>

                                <th pSortableColumn="itemId">{{lbl_id}}<p-sortIcon field="itemId">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="descri">{{lbl_description}}<p-sortIcon field="descri">
                                    </p-sortIcon>
                                </th>

                                <th pSortableColumn="quantity">{{lbl_quantity}}<p-sortIcon field="quantity">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="quantity">{{lbl_quantity}}<p-sortIcon field="quantity">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="quantity">{{lbl_total}}<p-sortIcon field="quantity"></p-sortIcon>
                                </th>



                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-value>
                            <tr>
                                <td>{{value.itemId}}</td>
                                <td>{{value.descri}}</td>
                                <td>{{value.sellQuantity}}</td>
                                <td>{{value.returnQuantity}}</td>
                                <td>{{value.sellQuantity-value.returnQuantity}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                {{lbl_total}} {{lstSum ? lstSum.length : 0 }} {{lbl_records}}
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </p-panel>
        </div>
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_manuals}}/{{lbl_distictives}}:</span>
                    <span class="p-text-bold">{{borrowItems!=null?borrowItems:""}}</span>
                </div>






                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <p-table #dt [value]="lstForm0" [rowHover]="true" dataKey="wrksId"
                        styleClass="p-datatable-responsive-demo"
                        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
                        [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <h5 class="p-m-0">{{lbl_services}}</h5>

                            </div>

                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>

                                <th pSortableColumn="serTyp">{{lbl_type}}<p-sortIcon field="serTyp">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="descri">{{lbl_schedule}}<p-sortIcon field="descri">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="docType">{{lbl_1a2a_partic}}<p-sortIcon field="docType">
                                    </p-sortIcon>
                                </th>
                                <th pSortableColumn="quantity">{{lbl_10a15a_particip}}<p-sortIcon field="quantity">
                                    </p-sortIcon>
                                </th>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-value>
                            <tr>
                                <td>{{value.serTyp}}</td>
                                <td>{{value.fromTime}} - {{value.toTime}}</td>
                                <td>{{value.partN2s}}</td>
                                <td>{{value.partN15s}}</td>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                {{lbl_total}} {{lstForm0 ? lstForm0.length : 0 }} {{lbl_records}}
                            </div>
                        </ng-template>
                    </p-table>
                </div>


            </p-panel>
        </div>


    </div>
</div>